// extracted by mini-css-extract-plugin
module.exports = {"secondary-icon":"secondary-icon__-CKyq","icon":"icon__rLpFP"};